<template>
  <div>
    <b-col cols="auto" :class="editable ? 'px-0 ml-4' : 'px-0 ml-3 rounded border'">
      <!-- Minus button - alleen zichtbaar in niet-edit modus -->
      <b-button v-if="!editable" variant="primary" class="mr-2">
        <b-icon icon="dash" @click="decreaseServings" variant="white"/>
      </b-button>
      
      <strong>
        <!-- Aantal porties/personen - verschillende weergave voor edit/view modus -->
        <span v-if="!editable">{{ servings }}</span>
        <b-form-spinbutton 
          class="mr-2 border-primary text-primary" 
          id="sb-inline" 
          v-if="editable"
          v-model="servingsLocal" 
          @change="updateServings" 
          inline
        />
        
        <!-- Label tekst (persoon/personen of portie/porties) -->
        <span class="ml-0" v-if="!editable">{{ servings == 1 ? " persoon" : " personen" }}</span>
        <span class="ml-0" v-if="editable">{{ servings == 1 ? " portie" : " porties" }}</span>
      </strong>
      
      <!-- Plus button - alleen zichtbaar in niet-edit modus -->
      <b-button v-if="!editable" variant="primary" class="ml-2">
        <b-icon icon="plus" @click="increaseServings" variant="white"/>
      </b-button>
    </b-col>
  </div>
</template>

<script>
export default {
  name: 'ServingsCounter',
  props: {
    servings: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      servingsLocal: this.servings
    };
  },
  watch: {
    servings(newVal) {
      this.servingsLocal = newVal;
    }
  },
  methods: {
    decreaseServings() {
      if (this.servingsLocal > 1) {
        this.servingsLocal--;
        this.$emit('change-servings', this.servingsLocal);
      }
    },
    increaseServings() {
      this.servingsLocal++;
      this.$emit('change-servings', this.servingsLocal);
    },
    updateServings(value) {
      this.$emit('change-servings', value);
    }
  }
};
</script>
